import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';

/**
 * Excursion hotel pickup: what the traveller should do at pickup time. The
 * excursion's departure time is not the hotel pickup time; the provider sends
 * the final pickup details.
 */
export const PickupInfoNotice = ({ testId = 'pickup-info-notice' }) => {
  const { t } = useTranslation();
  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50 p-3 text-xs text-primary space-y-1" data-testid={testId}>
      <p className="font-semibold flex items-center gap-1.5">
        <Info className="w-4 h-4 text-sky-600 shrink-0" /> {t('pickupNotice.title')}
      </p>
      <p>{t('pickupNotice.lobby')}</p>
      <p>{t('pickupNotice.delay')}</p>
      <p>{t('pickupNotice.stay')}</p>
    </div>
  );
};

export default PickupInfoNotice;
